<template>
  <b-media no-body>
    <div class="d-flex justify-content-center align-self-center icon-left">
      <GjIcon
        size="24"
        :name="icon"
      />
    </div>
    <b-media-body class="my-auto">
      <span class="font-weight-bolder mb-0 custom-title">
        {{ title }}
      </span>
      <b-card-text class="font-small-3 mb-0">
        {{ subtitle }}
      </b-card-text>
    </b-media-body>
  </b-media>
</template>
<script>
import {
  BMedia, BMediaBody,
} from 'bootstrap-vue'

export default {
  name: 'DashboardStatistic',
  components: {
    BMedia,
    BMediaBody,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-title{
  font-size: 1.5rem;
}
</style>
